import { render, staticRenderFns } from "./PatientDetailPreviousSurgeriesPage.vue?vue&type=template&id=0d3b1ee5&scoped=true&"
import script from "./PatientDetailPreviousSurgeriesPage.vue?vue&type=script&lang=js&"
export * from "./PatientDetailPreviousSurgeriesPage.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetailPreviousSurgeriesPage.vue?vue&type=style&index=0&id=0d3b1ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b1ee5",
  null
  
)

export default component.exports